import type { CategoryContent } from './row.js';

export const SWISS_HISTORY: CategoryContent = {
  bscba: [
    [
      'In what year did the three Forest Cantons traditionally found the Swiss Confederacy?',
      [
        '1291',
        '1315',
        '1513',
        '1648',
      ],
      0,
      'The Oath of Rütli in 1291 marks the legendary founding of the Swiss Confederacy by Uri, Schwyz, and Unterwalden.',
    ],
    [
      'Which treaty formally recognized Swiss independence from the Holy Roman Empire in 1648?',
      [
        'Treaty of Westphalia',
        'Peace of Augsburg',
        'Treaty of Utrecht',
        'Peace of Nystad',
      ],
      0,
      'The Treaty of Westphalia (1648) formally recognized Swiss independence and excluded Switzerland from Holy Roman Empire jurisdiction.',
    ],
    [
      'What was the Helvetic Republic?',
      [
        'A French-imposed centralized state created by Napoleon in 1798',
        'A medieval merchant confederation along the Rhine',
        'A coalition of Protestant cantons during the Reformation',
        'A neutral government entity founded by the League of Nations',
      ],
      0,
      'The Helvetic Republic (1798–1803) was a short-lived French satellite state imposed on Switzerland after Napoleon\'s invasion.',
    ],
    [
      'Which Swiss canton was historically most famous for providing mercenary soldiers to foreign powers?',
      [
        'Zug',
        'Bern',
        'Appenzell',
        'Glarus',
      ],
      0,
      'Zug produced many of the Swiss mercenaries hired by the Papacy, France, and other European powers from the 15th through 18th centuries.',
    ],
    [
      'In what year did Switzerland adopt its first modern federal constitution?',
      [
        '1848',
        '1815',
        '1798',
        '1878',
      ],
      0,
      'The 1848 Federal Constitution transformed Switzerland from a loose confederation into a modern federal state with a bicameral legislature.',
    ],
    [
      'Which religious leader led the Reformation in Zurich and shaped early Swiss Protestant theology?',
      [
        'Huldrych Zwingli',
        'Martin Luther',
        'John Calvin',
        'Johannes Oecolampadius',
      ],
      0,
      'Huldrych Zwingli led the Zurich Reformation (1519–1531) and influenced Protestant development distinct from Luther\'s and Calvin\'s movements.',
    ],
    [
      'The Peace of Kappel (1531) established which principle in Swiss cantonal relations?',
      [
        'Cantons could choose their own religion',
        'All cantons must adopt Reformation theology',
        'Religious authority rested with the federal government',
        'The Pope held veto power over cantonal laws',
      ],
      0,
      'The Peace of Kappel enshrined cantonal religious autonomy, allowing each canton to determine its own faith—a foundation for Swiss pluralism.',
    ],
    [
      'When did Switzerland formally establish a policy of permanent neutrality?',
      [
        'In 1815, after the Napoleonic Wars',
        'In 1291 with the Rütli Oath',
        'During the Reformation in the 16th century',
        'In 1848 with the federal constitution',
      ],
      0,
      'Following the Napoleonic Wars, Switzerland adopted permanent neutrality in the 1815 Treaty of Paris, reinforced at the Congress of Vienna.',
    ],
    [
      'Which city hosted the League of Nations headquarters, reflecting Switzerland\'s diplomatic role?',
      [
        'Geneva',
        'Bern',
        'Zurich',
        'Lucerne',
      ],
      0,
      'Geneva became the League of Nations headquarters in 1920, established there because of Switzerland\'s neutral status and diplomatic expertise.',
    ],
    [
      'What was the Battle of Marignano\'s significance for Swiss military history?',
      [
        'It ended Swiss military dominance in Europe',
        'It established Swiss independence from Austria',
        'It was the founding battle of the Confederacy',
        'It secured Swiss control of Alpine passes',
      ],
      0,
      'The 1515 Battle of Marignano, a French victory, marked the end of Swiss military expansion into Italy and Swiss mercenary dominance.',
    ],
    [
      'How many cantons formed the original Swiss Confederacy according to tradition?',
      [
        'Three (Uri, Schwyz, Unterwalden)',
        'Four (adding Lucerne)',
        'Seven (the founding members of the modern federation)',
        'Thirteen (the final number under the old confederation)',
      ],
      0,
      'The three Forest Cantons—Uri, Schwyz, and Unterwalden—formed the legendary founding nucleus of the Swiss Confederacy in 1291.',
    ],
    [
      'Which canton joined the Confederacy fourth, expanding it beyond the Forest Cantons?',
      [
        'Lucerne (1332)',
        'Zurich (1351)',
        'Bern (1353)',
        'Solothurn (1481)',
      ],
      0,
      'Lucerne joined in 1332, becoming the fourth member and the first to expand the original three-canton union.',
    ],
    [
      'What unique feature of Swiss government was embedded in the 1848 Constitution and expanded in 1874?',
      [
        'Direct democracy via referendums',
        'An elected executive president',
        'A bicameral legislature',
        'Mandatory military service',
      ],
      0,
      'The 1848 Constitution introduced direct democracy; the 1874 revision added the popular initiative, allowing citizens to propose constitutional changes.',
    ],
    [
      'Which conflict in 1847 tested the new federal structure and centralist versus conservative forces?',
      [
        'The Sonderbund War',
        'The Zwingli Wars',
        'The Kappel Conflicts',
        'The Swiss Civil War of 1798',
      ],
      0,
      'The Sonderbund War (1847) saw seven conservative Catholic cantons resist federal centralization; the Federalists won in weeks.',
    ],
    [
      'What role did Swiss banks develop that became central to Switzerland\'s 20th-century identity?',
      [
        'Discreet, neutral financial safe havens',
        'Monopoly holders of Alpine mineral wealth',
        'Headquarters of the European banking cartel',
        'Enforcers of the papal financial system',
      ],
      0,
      'Swiss banks cultivated reputations for discretion, safety, and political neutrality, making Switzerland a trusted venue for international finance.',
    ],
  ],
  msc: [
    [
      'What structural principle did the 1815 Congress of Vienna restoration establish for the Swiss Confederacy?',
      [
        'Autonomous cantons, united externally, neutrality guaranteed',
        'A centralized federal government with appointed cantonal governors',
        'Religious uniformity imposed across all territories',
        'Military subordination to the Concert of Europe',
      ],
      0,
      'The 1815 settlement restored the confederation of sovereign cantons, formalized Swiss perpetual neutrality, and incorporated Switzerland into the European balance of power.',
    ],
    [
      'How did the Act of Mediation (1803) under Napoleon differ from the Helvetic Republic\'s centralism?',
      [
        'Semi-autonomy under a weak central authority',
        'It abolished all cantonal governments',
        'It increased centralization beyond the Helvetic Republic',
        'It established direct democracy',
      ],
      0,
      'The Act of Mediation partially restored cantonal autonomy while keeping a weaker central structure than the Helvetic Republic but stronger than the old confederation.',
    ],
    [
      'What was the ideological conflict underlying the Sonderbund War beyond surface religious division?',
      [
        'Federalism versus cantonal sovereignty',
        'Free trade versus protectionism',
        'Democratic representation versus aristocracy',
        'Mercenary service versus pacifism',
      ],
      0,
      'The Sonderbund War pitted conservative Catholic cantons defending local autonomy against federalists pushing centralized authority and secular, liberal modernization.',
    ],
    [
      'Which specific provision of the 1848 Constitution reflected the federalist victory in the Sonderbund War?',
      [
        'Stronger federal legislative power',
        'Elimination of all cantonal governments',
        'Mandatory Protestantism',
        'Abolition of local courts',
      ],
      0,
      'The 1848 Constitution centralized authority more than any prior settlement, reflecting the federalists\' decisive military and political victory.',
    ],
    [
      'How did Huldrych Zwingli\'s theology diverge from Martin Luther\'s on the question of communion?',
      [
        'Symbolic vs real presence in communion',
        'Zwingli accepted papal authority; Luther rejected it',
        'Zwingli opposed purgatory; Luther accepted it',
        'Zwingli rejected predestination; Luther embraced it',
      ],
      0,
      'Zwingli\'s symbolic interpretation of the Lord\'s Supper differed fundamentally from Luther\'s doctrine of real presence, dividing Protestant theology.',
    ],
    [
      'What consequence did the Marburg Colloquy (1529) have for Swiss and German Protestant unity?',
      [
        'It exposed the Zwingli-Luther split',
        'It unified all Protestants under one doctrine',
        'It led to Catholic restoration',
        'It established the papacy\'s authority',
      ],
      0,
      'The 1529 Marburg Colloquy revealed the Eucharistic divide between Zwingli and Luther, fragmenting Protestant efforts to present a unified front.',
    ],
    [
      'How did the cantonal franchise differ between the 1848 Constitution and the 1874 revision regarding popular participation?',
      [
        'The 1874 revision added the popular initiative',
        'The 1848 Constitution had stronger direct democracy',
        'The 1874 revision eliminated referendums',
        'Neither altered the franchise system',
      ],
      0,
      'The 1874 revision added the popular initiative, enabling citizens to directly draft and propose constitutional amendments—a deepening of direct democracy.',
    ],
    [
      'What economic shift occurred in Swiss cantons following the decline of organized mercenary recruitment after 1815?',
      [
        'Cantons shifted to textiles, watches, machinery',
        'Banking alone replaced all mercenary income',
        'Switzerland became dependent on agricultural exports',
        'No economic transition was necessary',
      ],
      0,
      'The post-1815 loss of mercenary income forced cantons to industrialize: textiles, watches, precision tools, and later chocolate emerged as new economic bases.',
    ],
    [
      'What role did Alfred Escher play in 19th-century Swiss federalism and infrastructure?',
      [
        'He championed Swiss railways',
        'He opposed federal power',
        'He led the Sonderbund War',
        'He was the first federal president',
      ],
      0,
      'Alfred Escher promoted railroad construction and federal power as tools of national integration, overcoming cantonal parochialism through infrastructure investment.',
    ],
    [
      'How did the principle of "cantonal religious autonomy" from 1531 inform the structure of Swiss federalism?',
      [
        'It set a precedent for regional autonomy in governance',
        'It applied only to religious matters, not political federalism',
        'It was abolished in 1848',
        'It created religious monarchy',
      ],
      0,
      'The Kappel principle—allowing each canton religious self-determination—became a model for federal protection of minority and regional rights in later constitutions.',
    ],
    [
      'What did the Bundesbrief (1291) actually specify regarding military and political obligations?',
      [
        'Mutual defense and dispute arbitration',
        'Complete political union under a single authority',
        'Religious uniformity',
        'Permanent neutrality',
      ],
      0,
      'The Bundesbrief established mutual defense pacts and dispute-resolution mechanisms, creating the first concrete bonds of the Confederacy.',
    ],
    [
      'How did Swiss banking secrecy become institutionalized in the 19th century?',
      [
        'Loose cantonal rules allowed low transparency',
        'A federal law in 1848 mandated secrecy',
        'The League of Nations established secrecy rules',
        'Banks were created by the government',
      ],
      0,
      'Loose cantonal regulation and weak federal oversight allowed private banks to flourish with discretionary account management, building Switzerland\'s banking reputation.',
    ],
    [
      'What institutional development strengthened Swiss neutrality after the Napoleonic Wars?',
      [
        'Non-participation and armed neutrality',
        'Disarmament and reliance on international law',
        'Joining international military alliances',
        'Abolishing the army',
      ],
      0,
      'Post-1815 Switzerland fortified its neutrality through guaranteed non-belligerence, maintenance of defensive forces, and diplomatic independence from power blocs.',
    ],
    [
      'How did the federal takeover of foreign policy in 1848 challenge traditional cantonal sovereignty?',
      [
        'Cantons lost diplomatic power',
        'Cantons retained all foreign policy power',
        'The federal government was weakened',
        'No change occurred',
      ],
      0,
      'The 1848 Constitution centralized foreign policy and military authority, stripping cantons of independent diplomatic and military power.',
    ],
    [
      'What historical factor made Geneva\'s religious radicalism under Calvin distinct from Zwingli\'s Zurich Reformation?',
      [
        'Calvin was stricter than Zwingli',
        'Zwingli was more theocratic than Calvin',
        'Geneva never reformed',
        'They were identical',
      ],
      0,
      'Calvin\'s Geneva enforced strict moral and doctrinal discipline through ecclesiastical courts; Zwingli\'s Zurich pursued civic reformation with less coercive policing.',
    ],
  ],
  phd: [
    [
      'How did the legendary dating of 1291 versus the Treaty of Brunnen (1315) reflect medieval confederation-building practices?',
      [
        'Defense, then autonomy',
        '1291 established monarchy',
        'They are the same event',
        '1315 predates 1291',
      ],
      0,
      'Medieval confederation grew through layered pacts: 1291\'s defensive alliance deepened in 1315\'s Treaty of Brunnen, institutionalizing territorial autonomy.',
    ],
    [
      'What evidence suggests the Rütli oath narrative was a 15th-century construct rather than a literal 1291 event?',
      [
        'It first appears in 1580s chronicles',
        'It was written by Napoleon',
        'Swiss historians have proven it authentic',
        'It appears in medieval manuscripts',
      ],
      0,
      'Modern scholarship dates the Rütli Oath narrative to Tschudi\'s 16th-century chronicles; the confederation itself is documented, but the oath is a heroic retroactive origin myth.',
    ],
    [
      'How did the Wintethur Agreement (1424) and subsequent city-canton conflicts reshape confederate authority structures?',
      [
        'Urban cantons gained more power',
        'Rural cantons retained absolute power',
        'No structural change occurred',
        'The confederation dissolved',
      ],
      0,
      'As Zurich and Bern grew economically powerful, urban cantons challenged Forest Canton hegemony, forcing more consultative confederate decision-making.',
    ],
    [
      'What historiographical debate surrounds the role of Habsburg pressure versus internal cantonal conflict in driving 1291 confederation?',
      [
        'Internal rivalries mattered more',
        'Historians universally agree on Habsburg threat',
        'No debate exists',
        'Habsburg pressure is disproven',
      ],
      0,
      'Recent scholarship emphasizes local disputes and alpine trade routes alongside Habsburg concerns, suggesting confederation emerged from complex local incentives, not simple liberation.',
    ],
    [
      'How did Zwingli\'s civic reformation theology differ from radical Anabaptist theology that also flourished in his Zurich sphere?',
      [
        'Zwingli vs Anabaptist split',
        'Zwingli was an Anabaptist',
        'There was no Anabaptist movement',
        'They were identical',
      ],
      0,
      'Zwingli defended magisterial reformation—state-sponsored church reform with state authority intact; Anabaptists rejected this, pushing toward sectarian church separation.',
    ],
    [
      'What was the historiographical significance of the Marburg Colloquy (1529) for understanding Protestant fragmentation in the Swiss context?',
      [
        'It split reform unity',
        'It unified all Protestants',
        'It had no significance',
        'It ended the Reformation',
      ],
      0,
      'Marburg exposed deep doctrinal rifts within reformed Protestantism, fragmenting potential unified resistance and contributing to varied cantonal religious outcomes.',
    ],
    [
      'How did the Helvetic Republic\'s code civil differ from the Napoleonic Code in its application to cantonal legal traditions?',
      [
        'It restored cantonal pluralism',
        'They were identical',
        'The code civil was accepted everywhere',
        'No legal changes occurred',
      ],
      0,
      'The Helvetic Republic imposed French law wholesale, but the 1803 Act of Mediation\'s retreat allowed cantons to retain modified local legal systems.',
    ],
    [
      'What structural tension between direct democracy and representative federalism persisted from the 1848 Constitution through the 1874 revision?',
      [
        'A safety valve for cantons',
        'No tension existed',
        'Direct democracy won completely',
        'Representation won completely',
      ],
      0,
      'The 1848-1874 period saw escalating popular initiative use as conservative cantons used direct democracy to block federal legislation, forcing the compromise initiative mechanism.',
    ],
    [
      'How did the decline of organized Swiss mercenary services relate to the professionalization of European standing armies post-1815?',
      [
        'Conscription made mercenaries obsolete',
        'Mercenary service remained unchanged',
        'Standing armies did not professionalize',
        'Switzerland continued recruiting mercenaries',
      ],
      0,
      'Professional conscripted armies displaced mercenary companies; Switzerland\'s military specialization became unemployable, necessitating economic diversification.',
    ],
    [
      'What was the historiographical debate regarding whether Swiss "neutrality" was genuine strategic independence or enforced isolation by the Concert of Europe?',
      [
        'Neutrality suited both sides',
        'Neutrality was entirely genuine',
        'It was complete isolation',
        'There is no debate',
      ],
      0,
      'Historians debate whether 1815 neutrality reflected Swiss choice or foreign powers\' preference for a weak, inert buffer state—likely both factors combined.',
    ],
    [
      'How did Alfred Escher\'s railway strategy reshape cantonal autonomy through economic integration?',
      [
        'Railways ended autonomy',
        'Railways had no political effect',
        'Escher opposed federalism',
        'Cantons remained autonomous',
      ],
      0,
      'Escher\'s federal railway vision created economic dependencies across cantons that made local autonomy increasingly untenable, advancing de facto centralization.',
    ],
    [
      'What unresolved historiographical question surrounds the popular initiative\'s introduction in the 1874 revision?',
      [
        'Reform, or just a valve',
        'It was purely democratic',
        'It was purely conservative',
        'There is no question',
      ],
      0,
      'The 1874 initiative has been read as progressive democratization or as a conservative concession to cantonal resistance—historians remain divided on its primary motivations.',
    ],
    [
      'How did Swiss banking discretion become legally institutionalized under Article 47 of the Swiss Banking Law (1934)?',
      [
        'It made secrecy a legal duty',
        'Banking secrecy was established in 1848',
        'It was never formalized',
        'It was abolished in 1934',
      ],
      0,
      'Article 47 of the 1934 Banking Law codified secrecy as criminal obligation, institutionalizing what had been cantonal custom into binding federal law.',
    ],
    [
      'What theoretical framework did early Swiss federalism (post-1815) provide for later federal theory, particularly regarding minority protection?',
      [
        'A model for consociationalism',
        'Switzerland had no theoretical influence',
        'Federalism originated elsewhere',
        'Swiss model was rejected',
      ],
      0,
      'Switzerland\'s federal compromise—protecting cantonal diversity while maintaining union—became a theoretical template for consociational democracy in multinational states.',
    ],
    [
      'How did Zwingli\'s death at Kappel (1531) complicate reformed theology\'s trajectory in Swiss cantons?',
      [
        'His death fragmented reform',
        'Zwingli survived the war',
        'His death unified all reformers',
        'He converted to Catholicism',
      ],
      0,
      'Zwingli\'s death ended Zurich\'s military supremacy; Calvin\'s later Geneva offered a more systematized reformed theology, gradually replacing Zwingli\'s less dogmatic civic reformation.',
    ],
  ],
  professor: [
    [
      'How does the Brunner-Gilomen revisionist framework problematize the teleology of "Swiss unification" as a coherent nation-building project from 1291 onward?',
      [
        'A retroactive 19th-century construct',
        'The traditional narrative is unproblematic',
        'Unification occurred immediately in 1291',
        'Switzerland was never unified',
      ],
      0,
      'Modern historiography (Brunner, Gilomen, Sieber-Lehmann) rejects linear unification narratives, stressing contingency and retroactive nation-building, particularly via 19th-century print media.',
    ],
    [
      'What was the historical function of the Rütli Oath legend in relation to Joseph Melchior Simler\'s and Aegidius Tschudi\'s 16th-century chronicles and Swiss identity construction?',
      [
        'Rival confessional propaganda',
        'The oath was historically accurate',
        'It had no identity function',
        'It was invented in the 19th century',
      ],
      0,
      'Tschudi and Simler retroactively anchored 16th-century religious disputes to a putative "ancient Swiss freedom"—the Rütli Oath served as a mythic origin point for competing confessional claims.',
    ],
    [
      'How did the "Alliances of Mutual Defence" (Schützbünde) structure pre-1291 regional competition versus later confederation-building narratives?',
      [
        'A common pact, later mythologized',
        'Schützbünde were unique to Switzerland',
        'They did not exist',
        'They unified all cantons',
      ],
      0,
      'Mutual defense pacts were ubiquitous in medieval Europe; Switzerland\'s historiography mystified what was a routine feudal arrangement into an exceptional founding narrative.',
    ],
    [
      'What does the delayed formalization of the confederate structure (the canon of 13 cantons not established until 1513) reveal about the confederation\'s actual institutional consolidation?',
      [
        'Lacked coherent structure for centuries',
        'The confederation was formally unified in 1291',
        'It never formalized',
        'It dissolved and reformed continuously',
      ],
      0,
      'Institutional historians note that the "confederation" remained loosely defined until 1513; early cantons operated as independent allies with limited consensus mechanisms.',
    ],
    [
      'How did Zwingli\'s Eucharistic theology relate to his emerging political theory of civic magistracy and sovereignty?',
      [
        'Symbol mirrored civic rule',
        'Zwingli had no political theory',
        'He rejected magistrates',
        'He was a Catholic theologian',
      ],
      0,
      'Zwingli\'s symbolic Eucharist theology mirrored his civic-magisterial ecclesiology: both depended on representation and magistral authority rather than hierarchical sacramental power.',
    ],
    [
      'What was the historiographical significance of the Marburg Colloquy\'s failure for reformed Protestantism\'s relationship to political state-formation in the Swiss context?',
      [
        'Cantons settled doctrine',
        'It unified all reformed churches',
        'It ended reformed theology',
        'It had no significance',
      ],
      0,
      'Marburg\'s doctrinal failure prevented reformed churches from presenting unified demands to magistrates; cantonal rulers thus retained arbitral power over theology, reinforcing cantonal autonomy.',
    ],
    [
      'How did the Helvetic Republic\'s attempted homogenization of cantonal law illuminate the subsequent federalist reaction of the 1815-1848 period?',
      [
        'Cantonal law was too entrenched to erase',
        'The republic succeeded in homogenization',
        'Federalists favored further centralization',
        'No reaction occurred',
      ],
      0,
      'The Helvetic Republic\'s legal centralization provoked cantonal backlash; 1815 and 1848 constitutions explicitly preserved cantonal legal autonomy as a learned lesson.',
    ],
    [
      'What was the role of the 1847 Sonderbund War in relation to the emergence of Swiss nationalist ideology vis-à-vis European romanticism?',
      [
        'It vindicated Swiss nationalism',
        'No nationalism emerged',
        'Nationalism preceded the war',
        'Switzerland remained non-nationalist',
      ],
      0,
      'Post-1847, Swiss intellectuals crafted a nationalist narrative of federal modernity triumphing over cantonal obscurantism, aligning Switzerland with European nationalist movements.',
    ],
    [
      'What was the historiographical debate regarding whether the decline of Swiss mercenary employment resulted from technological military change or from geopolitical restructuring of the Concert of Europe?',
      [
        'Both factors mattered',
        'Only technology mattered',
        'Only geopolitics mattered',
        'Mercenaries never declined',
      ],
      0,
      'Historians debate mercenary decline\'s causes: some emphasize standing armies\' rise; others stress the Concert of Europe\'s relative peace reducing mercenary demand.',
    ],
    [
      'How did Alfred Escher\'s 1859 founding of the Federal Railways (Bundesbahn) represent a theoretically innovative approach to federalist integration?',
      [
        'He pushed federal infrastructure',
        'Railways had no theoretical importance',
        'Escher opposed state ownership',
        'Railways were cantonal',
      ],
      0,
      'Escher\'s federal railroad represented an innovative federalist theory: integration through state-owned infrastructure transcending cantonal boundaries, not just constitutional design.',
    ],
    [
      'What unresolved historiographical question concerns the relationship between the 1874 popular initiative and Swiss resistance to supranational European integration in the 20th century?',
      [
        'Possibly a factor',
        'They are directly related',
        'They are unrelated',
        'There is no question',
      ],
      0,
      'Scholars debate whether direct democracy institutionally predisposed Switzerland toward Eurocepticism by empowering cantonal/popular vetoes of integration, or if this is post-hoc rationalization.',
    ],
    [
      'How did the 1934 Banking Law\'s Article 47 (banking secrecy) relate to Swiss neutrality ideology and evasion of League of Nations sanctions enforcement?',
      [
        'It hides real coercion behind Swiss unity',
        'Banking secrecy prevented sanctions evasion',
        'It was unrelated to neutrality',
        'Secrecy was never formalized',
      ],
      0,
      'The 1934 Banking Law\'s timing (League of Nations era) reflects Switzerland\'s strategic use of banking secrecy as a neutrality tool, enabling de facto sanctions circumvention.',
    ],
    [
      'What does the historiographical concept of "Swiss federalism as consociationalism" (Arend Lijphart\'s framework applied retroactively) reveal and obscure about historical cantonal relations?',
      [
        'It hides real coercion behind consensus',
        'Consociation fully explains Swiss federalism',
        'It reveals nothing',
        'It is anachronistic',
      ],
      0,
      'Lijphart\'s consociational model aptly captures Swiss elite accommodation but overlooks coercion: 1847\'s Federalist military victory was not consensual; elite compromise followed defeat.',
    ],
    [
      'How did the historiographical debate over "Zwingli as proto-nationalist" versus "Zwingli as civic reformer" shape modern interpretations of Swiss religious exceptionalism?',
      [
        'It fuels debate on Swiss nationalism',
        'There is no debate',
        'All historians agree he was nationalist',
        'He was not civic',
      ],
      0,
      'Historiographical reading of Zwingli as nationalist versus institutionalist affects how scholars frame modern Switzerland\'s multinational character; the tension remains unresolved.',
    ],
    [
      'What does the historiographical erasure of Genevese and Valais history from "Swiss" narratives until the 1815 annexations reveal about retroactive nation-building and the constructed nature of Swiss territorial identity?',
      [
        'A 19th-century construct',
        'Geneva was always Swiss',
        'Valais was never Swiss',
        'Borders were fixed in 1291',
      ],
      0,
      'Modern Switzerland\'s borders are 1815 artifacts; Geneva and Valais\'s absence from pre-1815 "Swiss" historiography reveals that Swiss national identity is a 19th-century retroactive construction, not an ancient given.',
    ],
  ],
};
